import React from 'react';

interface Props {
  text: string;
}

export const PlanTextCard: React.FC<Props> = ({ text }) => (
  <p className="text-body-14 rounded-xl bg-card p-4 whitespace-pre-line text-muted-foreground shadow-card contrast:border contrast:border-border">
    {text}
  </p>
);
